import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, SearchIcon } from 'lucide-react';
const lyrics = [{
  id: 1,
  title: 'ENGLISH ROSE',
  image: 'https://fabricreality.com/wp-content/uploads/2022/09/NEW-ENGLISH-ROSE.png',
  alt: 'English Rose lyrics',
  album: 'Fabric Reality EP',
  year: '2022'
}, {
  id: 2,
  title: 'MY LAST MIDNIGHT',
  image: 'https://fabricreality.com/wp-content/uploads/2022/09/MY-LAST-MIDNIGHT-LYRICS.png',
  alt: 'My Last Midnight lyrics',
  album: 'Fabric Reality EP',
  year: '2022'
}, {
  id: 3,
  title: 'SUNSET ON SATURN',
  image: 'https://fabricreality.com/wp-content/uploads/2022/09/NEW-SUNSET.png',
  alt: 'Sunset On Saturn lyrics',
  album: 'Fabric Reality EP',
  year: '2022'
}, {
  id: 4,
  title: 'A HUMAN BEING OF PLANET EARTH',
  image: 'https://fabricreality.com/wp-content/uploads/2022/09/NEW-HUMAN.png',
  alt: 'A Human Being Of Planet Earth lyrics',
  album: 'Fabric Reality EP',
  year: '2022'
}, {
  id: 5,
  title: 'EASE MY MIND',
  image: 'https://fabricreality.com/wp-content/uploads/2022/09/NEW-EASE-MY-MIND.png',
  alt: 'Ease My Mind lyrics',
  album: 'Fabric Reality EP',
  year: '2022'
}, {
  id: 6,
  title: 'EXHIBITION',
  image: 'https://fabricreality.com/wp-content/uploads/2022/09/NEW-EXHIBITION-1-e1648686271558.png',
  alt: 'Exhibition lyrics',
  album: 'Fabric Reality EP',
  year: '2022'
}, {
  id: 7,
  title: 'HOW IT FEELS TO LOVE YOU LATELY',
  image: 'https://fabricreality.com/wp-content/uploads/2022/09/NEW-HOW-IT-FEELS.png',
  alt: 'How It Feels To Love You Lately lyrics',
  album: 'Fabric Reality EP',
  year: '2022'
}, {
  id: 8,
  title: 'THE MOON ON THE RIVER',
  image: 'https://fabricreality.com/wp-content/uploads/2022/09/NEW-MOON-ON-THE-RIVER-1.png',
  alt: 'The Moon On The River lyrics',
  album: 'Fabric Reality EP',
  year: '2022'
}, {
  id: 9,
  title: 'SUNCHILDREN',
  image: 'https://fabricreality.com/wp-content/uploads/2022/09/Copy-of-NEW-SUNCHILDREN.png',
  alt: 'Sunchildren lyrics',
  album: 'Upcoming Release',
  year: '2023'
}, {
  id: 10,
  title: "I'M ON THE RUN",
  image: 'https://fabricreality.com/wp-content/uploads/2022/09/Copy-of-IM-ON-THE-RUN-LYRICS-2.png',
  alt: "I'm On The Run lyrics",
  album: 'Upcoming Release',
  year: '2023'
}];
const Lyrics = () => {
  const [currentLyric, setCurrentLyric] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [showList, setShowList] = useState(false);
  const filteredLyrics = lyrics.filter(lyric => lyric.title.toLowerCase().includes(searchTerm.toLowerCase()) || lyric.album.toLowerCase().includes(searchTerm.toLowerCase()));
  const nextLyric = () => {
    setCurrentLyric(prev => (prev + 1) % lyrics.length);
  };
  const prevLyric = () => {
    setCurrentLyric(prev => (prev - 1 + lyrics.length) % lyrics.length);
  };
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
    if (e.target.value) {
      setShowList(true);
    }
  };
  const selectLyric = (index: number) => {
    setCurrentLyric(index);
    setSearchTerm('');
    setShowList(false);
  };
  return <section className="pt-28 md:pt-36 pb-16" data-id="element-476">
      <div className="max-w-4xl mx-auto" data-id="element-477">
        <h2 className="text-5xl font-bold mb-12 font-mono text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-400 inline-block" data-id="element-478">
          LYRICS
        </h2>
        <div className="mb-8" data-id="element-479">
          <div className="relative" data-id="element-480">
            <input type="text" placeholder="Search songs by title or album..." value={searchTerm} onChange={handleSearchChange} className="w-full px-4 py-3 pl-10 bg-gray-900/70 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-pink-500 text-white" data-id="element-481" />
            <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-482" />
            {showList && searchTerm && <div className="absolute z-10 mt-2 w-full bg-gray-900/95 border border-gray-700 rounded-lg shadow-xl max-h-60 overflow-y-auto" data-id="element-483">
                {filteredLyrics.length > 0 ? filteredLyrics.map((lyric, index) => <button key={lyric.id} className="w-full text-left px-4 py-3 hover:bg-gray-800 flex justify-between items-center border-b border-gray-800 last:border-0" onClick={() => selectLyric(lyrics.findIndex(l => l.id === lyric.id))} data-id="element-484">
                      <span className="text-white" data-id="element-485">{lyric.title}</span>
                      <span className="text-sm text-gray-400" data-id="element-486">
                        {lyric.album}
                      </span>
                    </button>) : <div className="px-4 py-3 text-gray-400" data-id="element-487">
                    No results found
                  </div>}
              </div>}
          </div>
        </div>
        <div className="relative" data-id="element-488">
          <div className="bg-black/60 backdrop-blur-sm p-6 rounded-lg border border-indigo-500/30 shadow-lg shadow-indigo-500/20" data-id="element-489">
            <div className="flex flex-col md:flex-row items-center justify-between mb-6" data-id="element-490">
              <div data-id="element-491">
                <h3 className="text-2xl font-bold text-white" data-id="element-492">
                  {lyrics[currentLyric].title}
                </h3>
                <div className="flex items-center mt-1 space-x-2" data-id="element-493">
                  <span className="text-pink-400" data-id="element-494">
                    {lyrics[currentLyric].album}
                  </span>
                  <span className="text-gray-400" data-id="element-495">•</span>
                  <span className="text-gray-400" data-id="element-496">
                    {lyrics[currentLyric].year}
                  </span>
                </div>
              </div>
              <div className="flex items-center space-x-2 mt-4 md:mt-0" data-id="element-497">
                <span className="text-gray-400 text-sm" data-id="element-498">
                  {currentLyric + 1} of {lyrics.length}
                </span>
              </div>
            </div>
            <div className="relative aspect-[3/4] max-w-lg mx-auto border border-purple-500/20 rounded-lg overflow-hidden shadow-lg shadow-purple-500/10" data-id="element-499">
              <img src={lyrics[currentLyric].image} alt={lyrics[currentLyric].alt} className="w-full h-full object-contain rounded-lg bg-black/50" data-id="element-500" />
            </div>
            <div className="flex justify-center mt-8" data-id="element-501">
              <button onClick={prevLyric} className="p-3 rounded-full bg-gray-800 hover:bg-gray-700 text-white transition-colors mr-4" aria-label="Previous lyrics" data-id="element-502">
                <ChevronLeftIcon size={24} data-id="element-503" />
              </button>
              <div className="flex items-center" data-id="element-504">
                {lyrics.map((_, index) => <button key={index} onClick={() => setCurrentLyric(index)} className={`w-3 h-3 rounded-full mx-1 transition-all ${index === currentLyric ? 'bg-pink-500 scale-125' : 'bg-gray-600 hover:bg-gray-500'}`} aria-label={`View lyrics for song ${index + 1}`} data-id="element-505" />)}
              </div>
              <button onClick={nextLyric} className="p-3 rounded-full bg-gray-800 hover:bg-gray-700 text-white transition-colors ml-4" aria-label="Next lyrics" data-id="element-506">
                <ChevronRightIcon size={24} data-id="element-507" />
              </button>
            </div>
          </div>
        </div>
        <div className="mt-12 grid grid-cols-2 md:grid-cols-5 gap-3" data-id="element-508">
          {lyrics.map((lyric, index) => <button key={lyric.id} onClick={() => setCurrentLyric(index)} className={`relative overflow-hidden rounded-lg aspect-square transition-all duration-300 ${index === currentLyric ? 'ring-2 ring-pink-500 scale-105 z-10' : 'opacity-60 hover:opacity-90'}`} data-id="element-509">
              <img src={lyric.image} alt={lyric.title} className="w-full h-full object-cover" data-id="element-510" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent flex items-end" data-id="element-511">
                <div className="p-2" data-id="element-512">
                  <p className="text-xs text-white font-semibold truncate" data-id="element-513">
                    {lyric.title}
                  </p>
                </div>
              </div>
            </button>)}
        </div>
      </div>
    </section>;
};
export default Lyrics;